import axios from '@/axios.js'
import { QuerySerialize } from '@/utils'
import { notifyServerError } from '@/layouts/notifies'

export default {
  createDocument(context, documentData) {
    return new Promise((resolve, reject) => {
      axios
        .post('documents', documentData)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  countDocuments(context, payload = { query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`documents/count/?${query}`)
        .then(response => {
          context.commit('SET_DOCUMENT_COUNT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchDocuments(context, payload = { skip: 0, limit: 0, query: {} }) {
    const query = QuerySerialize(payload.query)
    return new Promise((resolve, reject) => {
      axios
        .get(`documents/?skip=${payload.skip}&limit=${payload.limit}&${query}`)
        .then(response => {
          context.commit('SET_DOCUMENT', response.data)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  fetchDocument(context, documentId) {
    return new Promise((resolve, reject) => {
      axios
        .get(`documents/${documentId}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  removeDocument({ commit }, documentId) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`documents/${documentId}`)
        .then(response => {
          commit('REMOVE_RECORD', documentId)
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editDocument(context, document) {
    return new Promise((resolve, reject) => {
      axios
        .put(`documents/${document.id}`, document.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  },
  editDocumentState(context, document) {
    return new Promise((resolve, reject) => {
      axios
        .put(`documents/${document.id}/state`, document.data)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          notifyServerError(error)
          reject(error)
        })
    })
  }
}
